import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-historique-objectif-annee-suivante',
  templateUrl: './historique-objectif-annee-suivante.component.html',
  styleUrls: ['./historique-objectif-annee-suivante.component.css']
})

export class HistoriqueObjectifAnneeSuivanteComponent implements OnInit {

  @Input() OBJECTIF_ANNEE_SUIVANTE: any
  public listObjectifSies: any = [];
  public listObjectifEnvironnement: any = [];
  public listObjectifOperationnel: any = [];
  public listObjectifFiabilites: any = [];
  public listObjectif: any = [];
  public typeVisualisation: any;
  public nbreObjectif: any;
  public response: any;
  public typeFiche: any;
  public entretien_id: any;
  public agent_id: any;
  public typeSauvegarde: any;
  public API_URL: any;
  public vueActive: any;
  public statut: any;

  constructor() { }

  public ngOnInit(): void {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    // console.log('URL IS :', url);
    // console.log('typeFiche IS :', this.typeFiche);
    // console.log('typeSauvegarde IS :', this.typeSauvegarde);
    // console.log('typeVisualisation IS :', this.typeVisualisation);
    // console.log('statut IS :', this.statut);
    // console.log('vueActive IS :', this.vueActive);
    // console.log('entretien_id IS :', this.entretien_id);
    // console.log('agent_id IS :', this.agent_id);
    this.getAllObjectifs();
  }

  public filterObjectifs(data) {
    data.forEach((element) => {
      if (element.rubrique_id === 3) {
        this.listObjectifSies.push(element);
      } else if (element.rubrique_id === 4) {
        this.listObjectifEnvironnement.push(element);
      } else if (element.rubrique_id === 5) {
        this.listObjectifOperationnel.push(element);
      } else if (element.rubrique_id === 6) {
        this.listObjectifFiabilites.push(element);
      } else {
        this.listObjectif.push(element);
      }
    });
    this.nbreObjectif = this.listObjectifSies?.length + this.listObjectifEnvironnement?.length + this.listObjectifOperationnel?.length + this.listObjectifFiabilites?.length
  }


  public getAllObjectifs() {
    this.filterObjectifs(this.OBJECTIF_ANNEE_SUIVANTE);
  }


}
